<template>
  <FlexCol gap-1 class="relative">
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <Flex gap3 items-center class="h-[42px]">
      <Flex v-for="(item, i) in items" :key="i" center gap1 @click="select(item)" class="cursor-pointer">
        <Avatar size="size-5" class="border-2">
          <Avatar size="size-2" class="bg-gray-950" v-if="localValue && item[itemValue] == localValue" />
        </Avatar>
        {{ item[itemText] }}
      </Flex>
    </Flex>
    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { watch, ref, computed } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  items: Array,
  itemValue: String,
  itemText: String,
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue)
const error = ref(props.error)
const open = ref(false)
const selectedItem = ref(null)

const text = computed(() => {
  const item = props.items.find((item) => {
    return item[props.itemValue] == localValue.value
  })

  if (item) {
    selectedItem.value = item
    return item[props.itemText]
  }
  return
})

const toggle = () => {
  open.value = !open.value
}

const clear = () => {
  selectedItem.value = null
  localValue.value = null
  toggle()
}

const select = (item) => {
  selectedItem.value = item
  localValue.value = item[props.itemValue]
  toggle()
}

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  }
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
